"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jsxFileName = "/opt/build/repo/plugins/wordsby-master/src/gatsby-browser.js";

var React = require("react");

var Preview = require("./components/Preview").default;

var InstantPublish = require("./components/InstantPublish").default;

var PageElement = require("./components/PageElement").default;

exports.wrapPageElement = function (_ref, pluginOptions) {
  var element = _ref.element,
      props = _ref.props;

  if (props.pageContext && props.pageContext.preview) {
    return React.createElement(Preview, (0, _extends2.default)({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      },
      __self: this
    }), React.createElement(PageElement, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      },
      __self: this
    }, element));
  } else if (!!pluginOptions && !!pluginOptions.instantPublish && process.env.NODE_ENV !== "development" || pluginOptions.instantPublish === "debug") {
    return React.createElement(InstantPublish, (0, _extends2.default)({
      debug: pluginOptions.instantPublish === "debug" && process.env.NODE_ENV === "development"
    }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      },
      __self: this
    }), React.createElement(PageElement, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      },
      __self: this
    }, element));
  } else {
    return React.createElement(PageElement, (0, _extends2.default)({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      },
      __self: this
    }), element);
  }
};

var _require = require("./constants"),
    imageClass = _require.imageClass,
    imageBackgroundClass = _require.imageBackgroundClass,
    imageWrapperClass = _require.imageWrapperClass; // This is for inline WP images


exports.onRouteUpdate = function () {
  var imageWrappers = document.querySelectorAll("." + imageWrapperClass); // https://css-tricks.com/snippets/javascript/loop-queryselectorall-matches/
  // for cross-browser looping through NodeList without polyfills

  var _loop = function _loop(i) {
    var imageWrapper = imageWrappers[i];
    var backgroundElement = imageWrapper.querySelector("." + imageBackgroundClass);
    var imageElement = imageWrapper.querySelector("." + imageClass);

    var onImageLoad = function onImageLoad() {
      backgroundElement.style.transition = "opacity 0.5s 0.5s";
      backgroundElement.style.opacity = 0;
      imageElement.style.transition = "opacity 0.5s";
      imageElement.style.opacity = 1;
      imageElement.removeEventListener("load", onImageLoad);
    };

    if (imageElement.complete) {
      backgroundElement.style.opacity = 0;
    } else {
      imageElement.style.opacity = 0;
      imageElement.addEventListener("load", onImageLoad);
    }
  };

  for (var i = 0; i < imageWrappers.length; i++) {
    _loop(i);
  }
};

exports.onClientEntry = function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("isomorphic-fetch"));
  });
};